import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import ContainerButton from '../../../components/button/ContainerButton';
import StateComponents from '../../../components/state-component/StateComponents';
import { routeName } from '../../../routes/routeName';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import { Box, Button, Checkbox, FormControl, FormControlLabel, IconButton, InputBase, Radio, RadioGroup, Stack, Tooltip, Typography } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ModeStandbyIcon from '@mui/icons-material/ModeStandby';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import InputTextField from '../../../components/input/inputTextField';
import { ReactComponent as BagRed } from '../../../assets/icons/bag-cross-red.svg'
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import { ExaminationApi } from '../../../api/examination-master/examination-master.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { alertError, alertSuccess } from '../../../components/alert/swal';
import { handleTypingNumber } from '../../../utils/app.utils';
export enum EXAMS {
    SINGLE_CHOICE = 'SINGLE_CHOICE',
    MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
    ANSWER = 'ANSWER',
}
export const exams_enum: {
    label: string;
    value: string;
    icon: any
}[] = [
        {
            label: "MANAGE_EXAMS_SINGLE_CHOICE",
            value: EXAMS.SINGLE_CHOICE,
            icon: <ModeStandbyIcon />
        },
        {
            label: "MANAGE_EXAMS_MULTIPLE_CHOICE",
            value: EXAMS.MULTIPLE_CHOICE,
            icon: <CheckBoxIcon />
        },
        {
            label: "MANAGE_EXAMS_ANSWER",
            value: EXAMS.ANSWER,
            icon: <LibraryBooksIcon />
        },

    ]
export default function ManageExamsDetail(props: any) {
    const { view } = props
    const { t } = useTranslation();
    const { id } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [form, setForm] = useState<any>()
    const [answer, setAnswer] = useState<any[]>([])
    // console.log(answer);

    const getDetail = async () => {
        await ExaminationApi.getExaminationById(id)
            .then((res) => {
                if (res.status < 300) {
                    setForm({
                        examination_name: res.data.data?.examination_name,
                        examination_desc: res.data.data?.examination_desc
                    })
                    setAnswer(res.data.data?.examination_details)
                }
            })
            .catch((err) => {
                console.log(err);
                // alertError("เพิ่มข้อสอบ", "เพิ่มข้อสอบ ไม่สำเร็จ");
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }

    useEffect(() => {
        if (id) {
            getDetail()
        }
    }, [])
    const handleSubmit = async () => {
        if (!form?.examination_name) {
            return alertError(t('MANAGE_EXAMS_SPECIFY_NAME'))
        }
        if (answer?.filter((item: any) => !item?.examination_type)?.length > 0) {
            return alertError(t('MANAGE_EXAMS_SPECIFY_TYPE'))
        }
        if (answer?.filter((item: any) => !item?.examination_question)?.length > 0) {
            return alertError(t('MANAGE_EXAMS_SPECIFY_QUESTION'))
        }

        const body = {
            ...form,
            examination_details: answer
        }
        dispatch(setLoading());
        if (id) {
            await ExaminationApi.updateExamination(+id, body)
                .then((res) => {
                    if (res.status < 300) {
                        alertSuccess(t("MANAGE_EXAMS_EDIT"), t("MANAGE_EXAMS_EDIT_COMPLETED"), undefined, () => {
                            navigate(routeName.admission.manage_exams)
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError(t("MANAGE_EXAMS_EDIT"), t("MANAGE_EXAMS_EDIT_FAILED"));
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        } else {
            await ExaminationApi.createExamination(body)
                .then((res) => {
                    if (res.status < 300) {
                        alertSuccess(t("MANAGE_EXAMS_ADD"), t("MANAGE_EXAMS_ADD_COMPLETED"),undefined, () => {
                            navigate(routeName.admission.manage_exams)
                        });
                        
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError(t("MANAGE_EXAMS_ADD"), t("MANAGE_EXAMS_ADD_FAILED"));
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        }

    }
    return (
        <div className='w-full'>
            <ContainerLayout
                title={!id ? t('MANAGE_EXAMS_ADD') : t("ข้อมูลข้อสอบ")}
                // hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("INTERVIEW_STUDENT_ENTRY_EXAM"),
                                disabled_match: true,
                                pathName: routeName.admission.manage_exams
                            },
                            {
                                key: "complaintSubmit",
                                name: t("MANAGE_EXAMS_MANAGE"),
                                pathName: routeName.admission.manage_exams
                            },
                            {
                                key: "complaintSubmit",
                                name: t("MANAGE_EXAMS_ADD"),
                                pathName: routeName.admission.manage_exams_add
                            },
                        ]}
                    />
                }
                buttonContent={
                    // <ContainerButton
                    //     justifyContent='flex-end'
                    //     buttonData={[
                    //         {
                    //             buttonProps: {
                    //                 onClick: handleDownloadReport
                    //             },
                    //             key: "DOWNLOAD_CSV",
                    //             label: t("COMPLAINTS_DOWNLOAD_CSV"),
                    //             seq: 1,
                    //             type: "DOWNLOAD_CSV"
                    //         }
                    //     ]}
                    // />
                    <></>
                }
                content={
                    <div className='w-full'>

                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[

                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                    },
                                    fieldProps: {
                                        heading: t("MANAGE_EXAMS_DETAILS"),
                                        value: form?.examination_name || '',
                                        onChange: (e) => {
                                            setForm({ ...form, examination_name: e.target.value })
                                        },
                                        disabled: view
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                    },
                                    fieldProps: {
                                        heading: t("MANAGE_EXAMS_DESCRIPTION"),
                                        value: form?.examination_desc || '',
                                        onChange: (e) => {
                                            setForm({ ...form, examination_desc: e.target.value })
                                        },
                                        multiline: true,
                                        minRow: 6,
                                        inputHeight: "auto",
                                        disabled: view
                                    }
                                },

                            ]} />

                        <div>
                            {answer.map((item, index: number) => {
                                return (
                                    <article key={index + 1} className='col-span-12 mt-6'>
                                        <Box
                                            sx={{
                                                boxShadow: '0px 0px 2px 2px rgba(0, 0, 0, 0.12)',
                                                borderRadius: '10px',
                                                borderBottom: '8px solid #0075CB'
                                            }}
                                        >
                                            <Box sx={{ padding: "20px" }}>
                                                <StateComponents
                                                    otherProps={{ spacing: 2 }}
                                                    typeProps={
                                                        [
                                                            {
                                                                seq: 1,
                                                                type: "SELECT",
                                                                gridProps: {
                                                                    xs: 12,
                                                                    md: 4
                                                                },
                                                                fieldProps: {
                                                                    labelId: "select_detail_type_" + index,
                                                                    placeholder: t("MANAGE_EXAMS_SPECIFY_TYPE"),
                                                                    heading: t("MANAGE_EXAMS_TYPE_LABEL"),
                                                                    options: exams_enum.map((x) => {
                                                                        return {
                                                                            ...x,
                                                                            label: t(x.label)
                                                                        }
                                                                    }),
                                                                    selectId: "select_detail_type_" + index,
                                                                    onChange: (e) => {
                                                                        setAnswer((prevData) =>
                                                                            prevData.map((p: any, i: number) =>
                                                                                index === i ? {
                                                                                    ...p, examination_type: e.target.value,
                                                                                    examination_answers: e.target.value === EXAMS.ANSWER ? [
                                                                                        {
                                                                                            examination_answer: '',
                                                                                            examination_answer_true: true
                                                                                        }
                                                                                    ] : [{
                                                                                        examination_answer: 'ตัวเลือก', // i18n-ignore
                                                                                        examination_answer_true: true,
                                                                                        examination_detail_point: 0,
                                                                                    }]
                                                                                } : p
                                                                            )
                                                                        );
                                                                    },
                                                                    value: item?.examination_type || '',
                                                                    disabled: view
                                                                }
                                                            },
                                                            {
                                                                seq: 2,
                                                                type: "TEXT_FIELD",
                                                                gridProps: {
                                                                    xs: 12,
                                                                    md: 12
                                                                },
                                                                fieldProps: {
                                                                    multiline: true,
                                                                    row: 3,
                                                                    maxRows: 5,
                                                                    inputHeight: "auto",
                                                                    disablePaddingMultiline: true,
                                                                    placeholder: t("MANAGE_EXAMS_SPECIFY_QUESTION"),
                                                                    heading: t("MANAGE_EXAMS_QUESTION_LABEL"),
                                                                    onChange: (e) => {
                                                                        setAnswer((prevData) =>
                                                                            prevData.map((p: any, i: number) =>
                                                                                index === i ? { ...p, examination_question: e.target.value } : p
                                                                            )
                                                                        );
                                                                    },
                                                                    value: item?.examination_question || '',
                                                                    disabled: view
                                                                }
                                                            },
                                                        ]
                                                    }
                                                />
                                                {
                                                    item?.examination_type === EXAMS.SINGLE_CHOICE &&
                                                    <Box sx={{ marginTop: 2, width: '100%' }}>
                                                        <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center', margin: '20px 0px' }}>
                                                            <Tooltip title={t('MANAGE_EXAMS_SELECT_ANSWER_INSTRUCTION')}>
                                                                <InfoOutlineIcon sx={{ cursor: 'pointer', color: '#FCAF17' }} />
                                                            </Tooltip>
                                                            <Typography sx={{ fontWeight: '600' }}>{t('MANAGE_EXAMS_OPTION')}</Typography>
                                                        </Box>
                                                        <FormControl fullWidth>
                                                            <RadioGroup>
                                                                {
                                                                    item.examination_answers && item.examination_answers.length > 0 ?
                                                                        <>

                                                                            {item?.examination_answers?.map((choice: any, choiceindex: any) => (
                                                                                <FormControlLabel
                                                                                    slotProps={{ typography: { "width": "100%" } }}
                                                                                    key={choiceindex + 1}
                                                                                    id={'choice' + choiceindex}
                                                                                    control={<Radio />}
                                                                                    disabled={view}
                                                                                    checked={choice?.examination_answer_true || ''}
                                                                                    onChange={(e: any) => {
                                                                                        const newValue = e.target.checked;
                                                                                        setAnswer((prevData) =>
                                                                                            prevData.map((q, qIndex) =>
                                                                                                qIndex === index
                                                                                                    ? {
                                                                                                        ...q,
                                                                                                        examination_answers: q.examination_answers.map(
                                                                                                            (ans: any, aIndex: number) =>
                                                                                                                aIndex === choiceindex
                                                                                                                    ? { ...ans, examination_answer_true: newValue }
                                                                                                                    : { ...ans, examination_answer_true: false }
                                                                                                        ),
                                                                                                    }
                                                                                                    : q
                                                                                            )
                                                                                        );
                                                                                    }}
                                                                                    label={
                                                                                        <>
                                                                                            <Stack
                                                                                                direction="row"
                                                                                                spacing={2}
                                                                                                sx={{
                                                                                                    justifyContent: "space-between",
                                                                                                    alignItems: "center",
                                                                                                }}
                                                                                            >
                                                                                                <Box sx={{ width: '60%' }}>
                                                                                                    <FormControl fullWidth>
                                                                                                        <InputBase disabled={view} fullWidth key={index + "" + choiceindex} sx={{ '&::after': { content: 'none' }, '&::before': { content: 'none' } }} type="text" name="" id=""
                                                                                                            value={choice?.examination_answer || ""}
                                                                                                            onChange={(e) => {
                                                                                                                const newValue = e.target.value;
                                                                                                                setAnswer((prevData) =>
                                                                                                                    prevData.map((q, qIndex) =>
                                                                                                                        qIndex === index
                                                                                                                            ? {
                                                                                                                                ...q,
                                                                                                                                examination_answers: q.examination_answers.map(
                                                                                                                                    (ans: any, aIndex: number) =>
                                                                                                                                        aIndex === choiceindex
                                                                                                                                            ? { ...ans, examination_answer: newValue }
                                                                                                                                            : ans
                                                                                                                                ),
                                                                                                                            }
                                                                                                                            : q
                                                                                                                    )
                                                                                                                );
                                                                                                            }}
                                                                                                        />
                                                                                                    </FormControl>
                                                                                                </Box>

                                                                                            </Stack>
                                                                                        </>
                                                                                    }
                                                                                />
                                                                            ))}
                                                                        </>
                                                                        :
                                                                        <></>
                                                                }
                                                                <FormControlLabel
                                                                    key={item.examination_answers ? item.examination_answers.length + 1 : 0}
                                                                    value="New"
                                                                    disabled
                                                                    control={<Radio />}
                                                                    label={
                                                                        <Typography sx={{ cursor: 'pointer' }} onClick={() => {
                                                                            setAnswer((prevData) =>
                                                                                prevData.map((q, qIndex) =>
                                                                                    qIndex === index
                                                                                        ? {
                                                                                            ...q,
                                                                                            examination_answers: [...q.examination_answers, {
                                                                                                examination_answer: 'ตัวเลือก', // i18n-ignore
                                                                                                examination_answer_true: false
                                                                                            }]
                                                                                        }
                                                                                        : q
                                                                                )
                                                                            );
                                                                        }}>{t('MANAGE_EXAMS_ADD_OPTION')}...</Typography>
                                                                    }
                                                                />

                                                            </RadioGroup>
                                                        </FormControl>

                                                    </Box>
                                                }
                                                {
                                                    item?.examination_type === EXAMS.MULTIPLE_CHOICE &&
                                                    <Box sx={{ marginTop: 2, width: '100%' }}>
                                                        <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center', margin: '20px 0px' }}>
                                                            <Tooltip title={t("MANAGE_EXAMS_SELECT_ANSWER_INSTRUCTION_2")}>
                                                                <InfoOutlineIcon sx={{ cursor: 'pointer', color: '#FCAF17' }} />
                                                            </Tooltip>
                                                            <Typography sx={{ fontWeight: '600' }}>{t('MANAGE_EXAMS_OPTION')}</Typography>
                                                        </Box>

                                                        <FormControl fullWidth>
                                                            {
                                                                item?.examination_answers && item?.examination_answers?.length > 0 ?
                                                                    <>

                                                                        {item.examination_answers.map((choice: any, choiceindex: any) => (
                                                                            <FormControlLabel
                                                                                slotProps={{ typography: { "width": "100%" } }}
                                                                                key={choiceindex + 1}
                                                                                id={'choice' + choiceindex}
                                                                                value={choice.examination_answer + '' + choiceindex}
                                                                                control={<Checkbox />}
                                                                                disabled={view}
                                                                                checked={choice?.examination_answer_true}
                                                                                onChange={(e: any) => {
                                                                                    const newValue = e.target.checked;
                                                                                    setAnswer((prevData) =>
                                                                                        prevData.map((q, qIndex) =>
                                                                                            qIndex === index
                                                                                                ? {
                                                                                                    ...q,
                                                                                                    examination_answers: q.examination_answers.map(
                                                                                                        (ans: any, aIndex: number) =>
                                                                                                            aIndex === choiceindex
                                                                                                                ? { ...ans, examination_answer_true: newValue }
                                                                                                                : ans
                                                                                                    ),
                                                                                                }
                                                                                                : q
                                                                                        )
                                                                                    );
                                                                                }}
                                                                                label={
                                                                                    <>
                                                                                        <Stack
                                                                                            direction="row"
                                                                                            spacing={2}
                                                                                            sx={{
                                                                                                justifyContent: "space-between",
                                                                                                alignItems: "center",
                                                                                            }}
                                                                                        >
                                                                                            <Box sx={{ width: '60%' }}>
                                                                                                <FormControl fullWidth>
                                                                                                    <InputBase fullWidth key={index + "" + choiceindex} sx={{ '&::after': { content: 'none' }, '&::before': { content: 'none' } }} type="text" name="" id=""
                                                                                                        value={choice?.examination_answer || ""}
                                                                                                        disabled={view}
                                                                                                        onChange={(e) => {
                                                                                                            const newValue = e.target.value;
                                                                                                            setAnswer((prevData) =>
                                                                                                                prevData.map((q, qIndex) =>
                                                                                                                    qIndex === index
                                                                                                                        ? {
                                                                                                                            ...q,
                                                                                                                            examination_answers: q.examination_answers.map(
                                                                                                                                (ans: any, aIndex: number) =>
                                                                                                                                    aIndex === choiceindex
                                                                                                                                        ? { ...ans, examination_answer: newValue }
                                                                                                                                        : ans
                                                                                                                            ),
                                                                                                                        }
                                                                                                                        : q
                                                                                                                )
                                                                                                            );
                                                                                                        }} />
                                                                                                </FormControl>

                                                                                            </Box>

                                                                                        </Stack>
                                                                                    </>
                                                                                }
                                                                            />
                                                                        ))}
                                                                    </> :
                                                                    <></>

                                                            }
                                                            <FormControlLabel
                                                                key={item.examination_answers ? item.examination_answers.length + 1 : 0}
                                                                value="New"
                                                                disabled
                                                                control={<Checkbox />}
                                                                label={
                                                                    <Typography sx={{ cursor: 'pointer' }} onClick={() => {
                                                                        setAnswer((prevData) =>
                                                                            prevData.map((q, qIndex) =>
                                                                                qIndex === index
                                                                                    ? {
                                                                                        ...q,
                                                                                        examination_answers: [...q.examination_answers, {
                                                                                            examination_answer: 'ตัวเลือก', // i18n-ignore
                                                                                            examination_answer_true: false
                                                                                        }]
                                                                                    }
                                                                                    : q
                                                                            )
                                                                        );
                                                                    }}>{t('MANAGE_EXAMS_ADD_OPTION')}...</Typography>
                                                                }
                                                            />
                                                        </FormControl>
                                                    </Box>}

                                                <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between', marginTop: "10px" }}>
                                                    <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                        <Typography>{t('MANAGE_EXAMS_SCORE')}</Typography>
                                                        <InputTextField disabled={view} style={{ width: '50px' }} onchange={
                                                            (e) => {
                                                                setAnswer((prevData) =>
                                                                    prevData.map((p: any, i: number) =>
                                                                        index === i ? { ...p, examination_detail_point: e.target.value } : p
                                                                    )
                                                                );
                                                            }
                                                        } value={item?.examination_detail_point || ''} onkeypress={handleTypingNumber} />
                                                    </Box>
                                                    {!view && <IconButton onClick={() => setAnswer(answer?.filter((_, ix: number) => ix !== index))}>
                                                        <BagRed />
                                                    </IconButton>}
                                                </Box>

                                            </Box>
                                        </Box>

                                    </article>
                                )

                            })}
                            <section className='grid grid-cols-12'>
                                <div className="col-span-12">
                                    <div className='mt-4'>
                                        <ContainerButton
                                            className='mt-6'
                                            otherProps={{
                                                spacing: 2
                                            }}
                                            justifyContent='end'
                                            buttonData={[
                                                {
                                                    key: "ADD2",
                                                    seq: 1,
                                                    type: "ADD2",
                                                    label: t("MANAGE_EXAMS_ADD_QUESTION"),
                                                    hidden: view,
                                                    buttonProps: {
                                                        onClick: () => {
                                                            setAnswer([...answer, {
                                                                examination_detail_point: '0',
                                                                examination_answers: [{ examination_answer: 'ตัวเลือก', examination_answer_true: true }] // i18n-ignore
                                                            }])
                                                        }
                                                    }
                                                },
                                            ]}
                                        />
                                    </div>
                                </div>
                            </section>
                        </div>
                        <ContainerButton
                            sxContainer={{ my: 3 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    buttonProps: {
                                        onClick: () => { navigate(-1) },
                                    },
                                    key: "CANCEL",
                                    label: t("INTERVIEW_STUDENT_BACK"),
                                    type: "CANCEL"
                                },
                                {
                                    seq: 2,
                                    buttonProps: {
                                        onClick: () => {
                                            handleSubmit()
                                        }
                                    },
                                    hidden: view,
                                    key: "SEND",
                                    label: t("INTERVIEW_STUDENT_CONFIRM"),
                                    type: 'SAVE'
                                },

                            ]}
                        />
                    </div>
                }
            />
        </div>
    )
}
